import { FC, useState } from "react"
import { useTranslation } from "react-i18next"

import { useAppDispatch } from "../../core/app/hooks"
import { UText } from "../../ui-component"
import {
  Box,
  Container,
  Step,
  StepLabel,
  Stepper,
} from "../../ui-component/mui.components"


export interface OrderProps {
  activeStep: number
  steps: { id: string; label: string; to: string }[]
}
const OrderSteps: FC<OrderProps> = ({ activeStep, steps }) => {
  const { t } = useTranslation("common")
  const [showAlert, setShowAlert] = useState(false)
  const dispatch = useAppDispatch()

  return (
    <>
      <Container sx={{ pt: 4 }}>
        <Box maxWidth={"lg"} sx={{ mb: 4 }}>
          <UText
            sxProp={{ display: "flex", justifyContent: "center", mb: "10px" }}
            variant={"h4"}
          >
            {t("overview.order.title")}
          </UText>
          <Stepper alternativeLabel nonLinear activeStep={activeStep}>
            {steps.map((item, index) => (
              <Step key={item.id} completed={activeStep > index}>
                <StepLabel>{item.label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
      </Container>
    </>
  )
}

export default OrderSteps
